/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The DragForm model module.
   * @module textbook/model/DragForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DragForm</code>.
   * @alias module:textbook/model/DragForm
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>DragForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/DragForm} obj Optional instance to populate.
   * @return {module:textbook/model/DragForm} The populated <code>DragForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pid')) {
        obj['pid'] = ApiClient.convertToType(data['pid'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 被拖拽的节点id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 拖拽位置的pid
   * @member {Integer} pid
   */
  exports.prototype['pid'] = undefined;
  /**
   * 拖拽位置的下标，从0开始
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;



  export default exports;
;


